import { getTestAttributes } from '@chillibean/component-library';
import { PropTypes } from 'prop-types';

function WarningMessage(props) {
  const { danger = false, message } = props;

  return (
    <div className={`alert ${danger ? 'alert-danger' : 'alert-warning'} form-template-active-modal`}>
      <i className="fa fa-exclamation-triangle" />
      <div className="form-template-active-modal--form-alert-text" {...getTestAttributes('alert-message')}>
        {message}
      </div>
    </div>
  );
}

WarningMessage.propTypes = {
  message: PropTypes.string.isRequired,
  danger: PropTypes.bool,
};

export default WarningMessage;
